/* Carry the current Quick Shop selection into native product navigation. */
(function () {
  'use strict';

  var stopWatchingFocus;

  function rememberQuickShopTrigger(event) {
    var trigger = event.target.closest && event.target.closest('.t4s-product [data-action-quickshop]');
    if (!trigger || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (stopWatchingFocus) stopWatchingFocus();
    var modal;
    var timer;
    var observer = new MutationObserver(function () {
      if (!modal) {
        var panel = document.querySelector('.t4s-modal .t4s-product-quick-shop');
        if (panel) {
          modal = panel.closest('.t4s-modal');
          clearTimeout(timer);
        }
      } else if (!modal.isConnected) {
        stop();
        if (trigger.isConnected && document.activeElement === document.body) {
          trigger.focus({ preventScroll: true });
        }
      }
    });
    function stop() {
      observer.disconnect();
      clearTimeout(timer);
      if (stopWatchingFocus === stop) stopWatchingFocus = null;
    }
    stopWatchingFocus = stop;
    observer.observe(document.body, { childList: true, subtree: true });
    // Failed AJAX requests must not leave a document observer running.
    timer = setTimeout(stop, 30000);
  }

  document.addEventListener('click', rememberQuickShopTrigger, true);

  function updateProductLink(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest('a[data-atease-quickshop-product-url]');
    if (!link) return;
    var panel = link.closest('.t4s-product-quick-shop');
    if (!panel) return;
    var base = link.getAttribute('data-atease-quickshop-product-url');
    var variant = panel.querySelector('form[action*="/cart/add"] [name="id"]');
    var url;
    try { url = new URL(base, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    if (variant && !variant.disabled && /^\d+$/.test(variant.value)) {
      url.searchParams.set('variant', variant.value);
    } else {
      url.searchParams.delete('variant');
    }
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  // Delegation also covers AJAX-inserted panels. Capture updates href before
  // existing navigation handlers; native clicks and new-tab actions are retained.
  ['click', 'auxclick', 'contextmenu', 'focusin'].forEach(function (type) {
    document.addEventListener(type, updateProductLink, true);
  });
})();
